<template>
    <div class="gtwm">
        <detailVue :articleId="article_id" ></detailVue>
    </div>
</template>
<script>
import detailVue from '../../components/detail.vue';
export default {
  components: {
    detailVue
  },
  data() {
    return {
     article_id:''
    }
  },
  created() {
    this.article_id = this.$route.query.article_id
  },
 methods: {
    onPopState(e) {
      this.$router.replace({path:'/'})
    },
  },
   mounted() {
    // 添加 popstate 事件监听
    window.history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', this.onPopState);
  },
  beforeDestroy() {
        // 在组件销毁前，移除 popstate 事件监听
        window.removeEventListener('popstate', this.onPopState)
    },
  watch: { // 监听，当路由发生变化的时候执行
     $route(to, from) {
      this.showList =true
     }
  }
};
</script>

<style lang="less" >
.gtwm img{
    width: 100%;
}
</style>